import React from 'react'

import { ArrowForwardIos } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Chip, CircularProgress, Typography } from '@mui/material'

import { formatLockerName } from '../../../../../../shared/functions/Locker/locker.functions'
import styles from './LockerBox.styles'
import { LockerBoxProps } from './LockerBox.types'

const LockerBox: React.FC<LockerBoxProps> = (props) => {
  const { boxId, doorId, lockerNumber, status, statusLabel, itemRequestId, traveler, shopper, isLoading, onClick } =
    props

  const locker = { doorId: doorId ?? boxId, lockerNumber }
  const hasLockerNumber = lockerNumber !== null && lockerNumber !== undefined

  const isClickable = Boolean(itemRequestId)

  const handleClick = () => {
    if (!isClickable) {
      return
    }

    onClick()
  }

  const formatName = (firstName: string, lastName: string) => {
    if (!firstName || !lastName) {
      return '-'
    }

    return `${firstName} ${lastName.slice(0, 1).toUpperCase()}.`
  }

  const bodyContent = () => {
    if (itemRequestId) {
      return (
        <Box sx={styles.bodyContent}>
          <Box sx={styles.bodyContentText}>
            <Typography variant="body2" sx={styles.assignmentText(true)}>
              Traveler: {formatName(traveler?.firstName ?? '', traveler?.lastName ?? '')}
            </Typography>

            <Typography variant="body2" sx={styles.assignmentText(true)}>
              Shopper: {formatName(shopper?.firstName ?? '', shopper?.lastName ?? '')}
            </Typography>

            <Typography variant="body2" sx={styles.assignmentText(true)}>
              Item Request: #{itemRequestId}
            </Typography>
          </Box>

          {isLoading ? (
            <CircularProgress size={16} sx={styles.loadingIndicator} />
          ) : (
            <ArrowForwardIos fontSize="small" sx={styles.arrowIcon} />
          )}
        </Box>
      )
    }

    return (
      <Box sx={styles.emptyStateBox}>
        <Typography variant="body2" sx={styles.assignmentText(false)}>
          Not currently assigned
        </Typography>
      </Box>
    )
  }

  return (
    <Card onClick={handleClick} sx={styles.getCardStyles(status, isClickable)} elevation={0}>
      <CardHeader
        title={
          <Box sx={styles.headerRow}>
            <Box sx={styles.lockerName}>
              <Typography variant="subtitle1" fontWeight={600}>
                {formatLockerName(locker)}
              </Typography>

              {hasLockerNumber && (
                <Typography variant="caption" color="text.secondary">
                  {locker.doorId}
                </Typography>
              )}
            </Box>

            <Chip label={statusLabel ?? status} size="small" sx={styles.statusChip(status)} />
          </Box>
        }
      />

      <CardContent sx={styles.cardContent}>{bodyContent()}</CardContent>
    </Card>
  )
}

export default LockerBox
